import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdvancedCommerce, AdvancedCommerceRecommendationsComponentDef } from '@df/module-advanced-commerce';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfUiModule } from '@df/ui/df-ui.module';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, NICmsContentField } from '@icms/core/content';
import { BasketRelatedProductsComponent } from '../../../basket/related-products/basket-related-products.component';
import { RelatedProductsComponent } from '../../../catalog/ui/related-products/related-products.component';
import { ScrollNavTargetDirective } from '../../../ui/scroll-nav/scroll-nav-target.directive';

declare module '@df/module-advanced-commerce' {
    namespace AdvancedCommerce {
        namespace Recommendations {
            interface ComponentData {
                title: string;
                subtitle?: string;
                minibasketVersion?: boolean;
            }
        }
    }
}

@Component({
    selector: 'advanced-commerce-recommendations',
    templateUrl: './advanced-commerce-recommendations.component.html',
    styleUrl: './advanced-commerce-recommendations.component.scss',
    standalone: true,
    imports: [
        BasketRelatedProductsComponent,
        DfUiModule,
        ICmsClientModule,
        RelatedProductsComponent,
        ScrollNavTargetDirective,
        SizeClassDirective,
        ToggleModule,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<AdvancedCommerceRecommendationsComponent>({
    ...AdvancedCommerce.Recommendations.CONFIG,
    hidePreview: true,
    fields: [
        <NICmsContentField.IToggleField>{
            type: NICmsContentField.EFieldType.toggle,
            key: 'minibasketVersion',
            title: 'Use minibasket version',
            default: false
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title of the carousel',
            required: true,
            default: 'Goes Perfectly With'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle',
            canShow: (data: AdvancedCommerce.Recommendations.ComponentData) => !data.minibasketVersion
        },
        ...AdvancedCommerce.Recommendations.CONFIG.fields
    ]
})
export class AdvancedCommerceRecommendationsComponent extends AdvancedCommerceRecommendationsComponentDef<AdvancedCommerce.Recommendations.ComponentData> {}
